import React from 'react'

const HowItWorks = () => {
  return (
    <div>HowItWorks</div>
  )
}

export default HowItWorks